import {Draggable, gsap, InertiaPlugin} from "gsap/all";
import {ScreenTransitionController} from "../base/ScreenTransitionController";
import $ from "jquery";

// Constructor
export class CBMSMainAppScreenTransition extends ScreenTransitionController {

  constructor() {
    super();
    this.codingAnimationLoop = null;
    this.$currentScreen = null;
  }

  screen1InAnimation() {
    // Clear existing loop before starting a new one
    this.codingAnimationLoop?.kill();
    this.codingAnimationLoop = null;

    const TYPING_SPEED = 0.05;
    const PUNCTUATION_DELAY = 0.0;
    const LINE_DELAY = 0.22;
    const MAX_CHARS = 600;

    const activeCalls = [];

    const tick = (el, $el, $wrapper, rawText, state) => {
      if (!document.body.contains(el)) return;

      if (state.index >= rawText.length) {
        state.displayedText += "\n";
        $el.text(state.displayedText);
        activeCalls.push(gsap.delayedCall(LINE_DELAY, () => {
          state.index = 0;
          tick(el, $el, $wrapper, rawText, state);
        }));
        return;
      }

      const char = rawText[state.index++];
      state.displayedText += char;

      if (state.displayedText.length > MAX_CHARS) {
        const nl = state.displayedText.indexOf("\n");
        state.displayedText = nl !== -1
          ? state.displayedText.slice(nl + 1)
          : state.displayedText.slice(-MAX_CHARS);
      }

      $el.text(state.displayedText);

      // CRITICAL: Scroll the WRAPPER, not the container
      if ($el[0].scrollHeight > $wrapper[0].clientHeight) {
        $wrapper[0].scrollTop = $el[0].scrollHeight;
      }

      let delay = TYPING_SPEED;
      if (char === "\n") delay = LINE_DELAY;
      else if (/[.,();{}]/.test(char)) delay = PUNCTUATION_DELAY;

      activeCalls.push(gsap.delayedCall(delay, () => tick(el, $el, $wrapper, rawText, state)));
    };

    $("#screen-1").find(".code-output").each((i, el) => {
      const $el = $(el);
      // Find the wrapper that is inside the container
      const $wrapper = $el.closest('.code-container').find('.code-wrapper');
      const rawText = el.dataset.text || "";

      $el.text("");
      const state = {index: 0, displayedText: ""};
      activeCalls.push(gsap.delayedCall(0, () => tick(el, $el, $wrapper, rawText, state)));
    });

    this.codingAnimationLoop = {
      kill: () => {
        activeCalls.forEach(c => c.kill());
        activeCalls.length = 0;
      }
    };
  }

  screen1InLeftAnimation() {
    // When going from screen 2 to 1
    gsap.set(this.$currentScreen.find(".title, button.start-button"), {clearProps: "all"});
    this.screenTransitionTimeline.add(() => {
      this.screen1InAnimation();
    });
    this.screenTransitionTimeline.fromTo(this.$currentScreen.find(".title, button.start-button"),
      {opacity: 0},
      {opacity: 1, duration: 1.0, ease: "power2.out"}
    );
    this.screenTransitionTimeline.to(this.$currentScreen.find(".code-output"), {
        opacity: 1.0, duration: 1.0, ease: "power2.out"
      }, '<'
    );
  }

  screen1OutAnimation() {
    // When going from screen 1 to 2
    const $overlay = $(".screen-transition-overlay");

    // Show overlay before starting transition
    this.screenTransitionTimeline.set($overlay, {display: 'block'});

    // Overlay expand
    this.screenTransitionTimeline.fromTo($overlay,
      {width: '0%', height: '0%', autoAlpha: 1.0},
      {width: '102%', height: '102%', duration: 2, ease: 'power2.inOut'}
    );

    // Background fade in
    this.screenTransitionTimeline.fromTo($overlay.find(".screen-transition-background"),
      {opacity: 0},
      {opacity: 1, duration: 2.0, ease: 'power2.inOut'},
      '<'
    );

    // Corners fade in
    this.screenTransitionTimeline.fromTo($overlay.find(".screen-transition-corner"),
      {opacity: 0},
      {opacity: 1, duration: 0.1, ease: 'power2.inOut'},
      '<'
    );

    // Title out
    this.screenTransitionTimeline.to(this.$currentScreen.find(".title"), {
      y: -160, opacity: 0,
      duration: 0.8, ease: 'power2.in'
    }, '<');

    // CTA out
    this.screenTransitionTimeline.to(this.$currentScreen.find("button.start-button"), {
      y: 160, opacity: 0,
      duration: 0.8, ease: 'power2.in'
    }, '<');

    // Code animation out
    this.screenTransitionTimeline.to(this.$currentScreen.find(".code-output"), {
      opacity: 0, duration: 0.8, ease: 'power2.in'
    }, '<');
  }

  screen2InAnimation() {
    // When entering screen 2 from any direction

    // Destroy coding animation loop
    this.codingAnimationLoop?.kill();
    this.codingAnimationLoop = null;

    // Always hide the overlay that is used between screen 1 and 2
    this.screenTransitionTimeline.to($(".screen-transition-overlay"), {
      autoAlpha: 0.0, duration: 0.8, ease: 'power2.out'
    });
    this.screenTransitionTimeline.set($(".screen-transition-overlay"), {display: 'none'});

    // Status bar
    this.screenTransitionTimeline.to($("#status-bar"), {
      autoAlpha: 1.0, duration: 1.20, ease: "power2.out"
    });
    this.screenTransitionTimeline.to(this.$currentScreen.find(".step-1"), {
      autoAlpha: 1.0, duration: 1.20, ease: "power2.out"
    }, '<');
    // this.screenTransitionTimeline.to(this.$currentScreen.find(".step-1"), {
    //   autoAlpha: 0.0, duration: 1.20, ease: "power2.out"
    // }, '+=1.20');
    // this.screenTransitionTimeline.to(this.$currentScreen.find(".step-2"), {
    //   autoAlpha: 1.0, duration: 1.20, ease: "power2.out"
    // });
  }

  screen2OutLeftAnimation() {
    // When going from screen 2 to 1

    // Status bar
    this.screenTransitionTimeline.to($("#status-bar"), {
      autoAlpha: 0.0, duration: 0.60, ease: "power2.inOut"
    });
    this.screenTransitionTimeline.to(this.$currentScreen.find(".step-1"), {
      autoAlpha: 0.0, duration: 0.60, ease: "power2.out"
    }, '<');
  }

  screen3InRightAnimation() {
    // Always hide the overlay that is used between screen 1 and 2
    this.screenTransitionTimeline.to($(".screen-transition-overlay"), {
      autoAlpha: 0.0, duration: 0.8, ease: 'power2.out'
    });
    this.screenTransitionTimeline.set($(".screen-transition-overlay"), {display: 'none'});
  }

  screen4InRightAnimation() {
    // Always hide the overlay that is used between screen 1 and 2
    this.screenTransitionTimeline.to($(".screen-transition-overlay"), {
      autoAlpha: 0.0, duration: 0.8, ease: 'power2.out'
    });
    this.screenTransitionTimeline.set($(".screen-transition-overlay"), {display: 'none'});
  }

  reset() {
  }
}
